module.exports = __webpack_public_path__ + "img/globalMPToolBg.1a2f6aec.png";